import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-img-preview',
  templateUrl: './img-preview.component.html',
  styleUrls: ['./img-preview.component.scss'],
})
export class ImgPreviewComponent implements OnInit {
  @Input() previewImgArray: any;
  @Output() closeEventTrigger = new EventEmitter();
  profileImgArray: any = [];
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1008,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  constructor() {}

  ngOnInit(): void {
    //console.log(this.previewImgArray);
    this.slideConfig['prevArrow'] = `.slickPrev`;
    this.slideConfig['nextArrow'] = `.slickNext`;

    this.previewImgArray.length <= 3
      ? (this.slideConfig.slidesToShow = 1)
      : (this.slideConfig.slidesToShow = 3);
  }

  closeImgPreview() {
    this.closeEventTrigger.emit(true);
  }
}
